<template xmlns="http://www.w3.org/1999/html">
  <SOSlotModal
      modal-title="PIN Console"
      :modal-id="id"
      @close="close"
  >
    <template v-slot:modal-body>
      <SOInputNumeric
          title="6 digit PIN Console"
          :placeholder="'Pin saat ini: ' + pinConsole"
          :max-length="6"
          @input="(val) => { input.pin = val }"
      />
    </template>
    <template v-slot:modal-footer>
      <SOButton
          text="Simpan"
          :primary="true"
          :full="true"
          :disable="input.pin.length !== 6"
          :loading="pageSetting.loadingPin"

          @action="updatePin"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputNumeric from "@/so-components/global/input/SOInputNumeric";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

export default {
  name: "SnapConsoleModalPin",
  components: {SOLoadingPage, SOInputNumeric, SOButton, SOInputNominal, SOSlotModal},
  props: {
    pinConsole: String,
    idConsole: String
  },
  data() {
    return {
      id: "modal-pin",
      input: {
        pin: 0
      },
      pageSetting:{
        loadingPin: false
      }
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async updatePin() {
      let payload = {
        idconsole: this.idConsole,
        idoutlet: this.$route.query.idoutlet,
        pin: this.input.pin
      }
      const res = await this.$store.dispatch("snapConsoleModule/changePinConsole", payload)
      this.pageSetting.loadingPin = true
      if (res.success){
        this.pageSetting.loadingPin = false
        this.$emit("onUpdateSuccess", res)
      }
    }
  },
  mounted() {
    $("#" + this.id).modal("show")
  },
}
</script>

<style scoped>

</style>